import { configureStore } from '@reduxjs/toolkit'

import { alertReducer } from './alertSlice'
import { authReducer } from './authSlice'
import filterReducer from './filterSlice'
import { regionReducer } from './regionSlice'
import tenantReducer from './tenantSlice'

export const store = configureStore({
  reducer: {
    tenant: tenantReducer,
    filters: filterReducer,
    auth: authReducer,
    region: regionReducer,
    alert: alertReducer,
  },

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: [
          'filters/setDate',
          'filters/initializeFilters',
          'filters/resetFilters',
          'alert/addAlert',
          'alert/initializeMockAlerts',
        ],
        // Ignore these field paths in all actions
        ignoredActionPaths: [
          'payload.date',
          'payload.defaultDate',
          'payload.timestamp',
        ],
        // Ignore these paths in the state
        ignoredPaths: [
          'filters.date',
          'filters.defaults.defaultDate',
          'alert.alerts',
        ],
      },
    }),

  devTools: import.meta.env.DEV,
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
